/**
 * @generated SignedSource<<1911542db8a4b00194894ad747339f32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Question_Question$data = {
  readonly description: string | null | undefined;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"QuestionActions_Question" | "QuestionSubheader_Question">;
  readonly " $fragmentType": "Question_Question";
};
export type Question_Question$key = {
  readonly " $data"?: Question_Question$data;
  readonly " $fragmentSpreads": FragmentRefs<"Question_Question">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Question_Question",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuestionSubheader_Question"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuestionActions_Question"
    }
  ],
  "type": "Question",
  "abstractKey": null
};

(node as any).hash = "c9d1a699fa174b8c7f7a69851957f29c";

export default node;
